import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Field } from 'formik';
import CustomInput from './CustomInput';
import { theme } from '../theme';
import { useFieldWidth, useIsResponsiveForm, } from '../intakeForm/ResponsiveFormContext';
/** Matches default CustomInput height when height prop is omitted. */
export const DEFAULT_LABELED_INPUT_HEIGHT = 36;
/** Aligns a sibling operator (e.g. "-") vertically with the LabeledField input. */
export const inputRowOperatorStyle = (inputHeight = DEFAULT_LABELED_INPUT_HEIGHT) => ({
    height: inputHeight,
    justifyContent: 'center',
    // Matches CustomInput textInput margin so flex-end lines up with the visible box.
    marginBottom: 10,
});
export const LabeledField = (props) => {
    const fieldWidth = useFieldWidth();
    const isSignup = useIsResponsiveForm();
    const signupInput = isSignup ? props.signupInput : undefined;
    const placeHolder = !props.readOnly ? props.placeholder : undefined;
    return (<View>
      {props.label ? (<View style={styles.row}>
          <Text style={styles.labelField}>{props.label}</Text>
          {!props.readOnly && props.required && (<Text style={[styles.labelField, styles.required]}>*</Text>)}
        </View>) : null}
      <View>
        <Field component={CustomInput} name={props.name} placeholder={placeHolder} width={fieldWidth(props.width)} height={props.height} multiline={props.multiline} {...signupInput} keyboardType={signupInput?.keyboardType ?? props.keyboardType} secureTextEntry={props.secureTextEntry} readOnly={props.readOnly}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    labelField: {
        marginTop: 10,
        marginLeft: 10,
        fontWeight: 'bold',
    },
    required: {
        color: theme.colors.dangerText,
    },
});
